import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaMapMarkerAlt, FaClock, FaBriefcase } from "react-icons/fa";

function OpenPosition() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getJobs = async () => {
    try {
      const response = await axios.get("https://app.unios.in/web/job-posts");
      setData(response.data || []);
    } catch (error) {
      console.error("Error fetching jobs:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getJobs();
  }, []);

  return (
    <div id="openRole" style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>Open Positions</h1>
        <p style={styles.subtitle}>
          Discover exciting career opportunities and join our growing team.
        </p>
      </div>

      <div style={styles.jobsGrid}>
        {loading ? (
          <div style={styles.loading}>Loading positions...</div>
        ) : data.length > 0 ? (
          data.map((job, i) => (
            <div key={i} style={styles.jobCard} className="job-card">
              <div style={styles.cardHeader}>
                <h3 style={styles.jobTitle}>{job.job_title}</h3>
                <span style={styles.statusBadge}>{job.status}</span>
              </div>

              <div style={styles.metaInfo}>
                <div style={styles.metaItem}>
                  <FaMapMarkerAlt style={styles.icon} />
                  <span>{job.location}</span>
                </div>
                <div style={styles.metaItem}>
                  <FaClock style={styles.icon} />
                  <span>{job.job_type}</span>
                </div>
                <div style={styles.metaItem}>
                  <FaBriefcase style={styles.icon} />
                  <span>{job.experience_required}</span>
                </div>
              </div>

              <p style={styles.description}>
                {job.job_description?.length > 120
                  ? `${job.job_description.substring(0, 120)}...`
                  : job.job_description}
              </p>

              <div style={styles.skillsContainer}>
                {job.skills_required
                  ?.split(",")
                  .slice(0, 3)
                  .map((skill, idx) => (
                    <span key={idx} style={styles.skillTag}>
                      {skill.trim()}
                    </span>
                  ))}
              </div>

              <div style={styles.footer}>
                <div style={styles.salary}>
                  {job.salary_min && job.salary_max ? (
                    <span>
                      ₹{job.salary_min} - ₹{job.salary_max}
                    </span>
                  ) : (
                    <span>Not disclosed</span>
                  )}
                </div>

                <a
                  href="#form"
                  style={styles.applyButton}
                  className="apply-button"
                >
                  Apply Now
                </a>
              </div>
            </div>
          ))
        ) : (
          <div style={styles.noJobs}>No positions available at the moment.</div>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "40px 20px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  header: {
    textAlign: "center",
    marginBottom: "40px",
  },
  title: {
    fontSize: "clamp(28px, 5vw, 36px)",
    fontWeight: "700",
    color: "#1a1a1a",
    margin: "0 0 12px 0",
  },
  subtitle: {
    fontSize: "clamp(14px, 2.5vw, 16px)",
    color: "#666",
    margin: "0",
    padding: "0 15px",
  },
  jobsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(min(350px, 100%), 1fr))",
    gap: "24px",
  },
  jobCard: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "20px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    transition: "all 0.3s ease",
    border: "1px solid #e8e8e8",
    cursor: "pointer",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "16px",
    gap: "12px",
    flexWrap: "wrap",
  },
  jobTitle: {
    fontSize: "clamp(18px, 3vw, 20px)",
    fontWeight: "600",
    color: "#1a1a1a",
    margin: "0",
    lineHeight: "1.3",
    flex: "1 1 auto",
    minWidth: "150px",
  },
  statusBadge: {
    backgroundColor: "#e8f5e9",
    color: "#2e7d32",
    padding: "4px 12px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "500",
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
  metaInfo: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    marginBottom: "16px",
  },
  metaItem: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "clamp(13px, 2vw, 14px)",
    color: "#555",
  },
  icon: {
    fontSize: "14px",
    color: "#888",
    flexShrink: 0,
  },
  description: {
    fontSize: "clamp(13px, 2vw, 14px)",
    color: "#666",
    lineHeight: "1.6",
    marginBottom: "16px",
  },
  skillsContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    marginBottom: "20px",
  },
  skillTag: {
    backgroundColor: "#f5f5f5",
    color: "#444",
    padding: "6px 12px",
    borderRadius: "6px",
    fontSize: "clamp(12px, 2vw, 13px)",
    fontWeight: "500",
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: "16px",
    borderTop: "1px solid #eee",
    gap: "12px",
    flexWrap: "wrap",
  },
  salary: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "clamp(14px, 2.5vw, 15px)",
    fontWeight: "600",
    color: "#1a1a1a",
  },
  applyButton: {
    backgroundColor: "#1976d2",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "10px 20px",
    fontSize: "clamp(13px, 2vw, 14px)",
    fontWeight: "600",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    whiteSpace: "nowrap",
  },
  loading: {
    textAlign: "center",
    padding: "40px",
    fontSize: "16px",
    color: "#666",
    gridColumn: "1 / -1",
  },
  noJobs: {
    textAlign: "center",
    padding: "60px 20px",
    fontSize: "16px",
    color: "#666",
    gridColumn: "1 / -1",
  },
};

// Add responsive styles and hover effects
if (typeof document !== "undefined") {
  const styleSheet = document.createElement("style");
  styleSheet.textContent = `
    .job-card:hover {
      box-shadow: 0 6px 20px rgba(0,0,0,0.12) !important;
      transform: translateY(-2px);
    }
    
    .apply-button:hover {
      background-color: #1565c0 !important;
    }
    
    .apply-button:active {
      transform: scale(0.98);
    }
    
    /* Tablet styles */
    @media (max-width: 768px) {
      .job-card {
        padding: 18px !important;
      }
    }
    
    /* Mobile styles */
    @media (max-width: 480px) {
      .job-card {
        padding: 16px !important;
      }
      
      .job-card > div:last-child {
        flex-direction: column !important;
        align-items: stretch !important;
      }
      
      .apply-button {
        width: 100% !important;
        padding: 12px 20px !important;
      }
    }
    
    /* Extra small mobile */
    @media (max-width: 360px) {
      .job-card h3 {
        font-size: 16px !important;
      }
      
      .job-card > div:first-child {
        gap: 8px !important;
      }
    }
  `;
  document.head.appendChild(styleSheet);
}

export default OpenPosition;
